import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';
import { WeekDaysEnum } from '../components/cron-job/enums/week-days.enum';

@Pipe({
  name: 'nextCronExecution',
  standalone: true,
})
export class NextCronExecutionPipe implements PipeTransform {
  transform(cron: string): string {
    const [seconds, minutes, hours, dom, month, dow] = cron.split(' ');
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const weekDays: WeekDaysEnum[] = [
      WeekDaysEnum.SUN,
      WeekDaysEnum.MON,
      WeekDaysEnum.TUE,
      WeekDaysEnum.WED,
      WeekDaysEnum.THU,
      WeekDaysEnum.FRI,
      WeekDaysEnum.SAT,
    ];

    let nowUTC = moment.utc();
    let nextRunUTC = moment.utc().seconds(0).milliseconds(0);

    nextRunUTC.minutes(parseInt(minutes));
    nextRunUTC.hours(parseInt(hours));

    if (nextRunUTC.isBefore(nowUTC)) {
      nextRunUTC.add(1, 'day');
    }

    if (dom !== '?' && dom !== '*' && dom) {
      const currentMonth = nextRunUTC.month(); // 0-indexed
      const currentYear = nextRunUTC.year();

      let day: number;

      if (dom === 'L') {
        day = moment.utc({ year: currentYear, month: currentMonth }).endOf('month').date();
      } else if (dom === 'L-1') {
        day = moment.utc({ year: currentYear, month: currentMonth }).endOf('month').subtract(1, 'day').date();
      } else if (/^\d+$/.test(dom)) {
        day = parseInt(dom, 10);
      }

      if (day) {
        nextRunUTC.date(day);

        if (nextRunUTC.isBefore(nowUTC)) {
          const nextMonth = moment.utc({ year: currentYear, month: currentMonth + 1 });
          if (dom === 'L') {
            day = nextMonth.endOf('month').date();
          } else if (dom === 'L-1') {
            day = nextMonth.endOf('month').subtract(1, 'day').date();
          }
          nextRunUTC = nextRunUTC.month(currentMonth + 1).date(day);
        }
      }
    }

    if (dow !== '?' && dow !== '*' && dow) {
      let targetDow: number = weekDays.findIndex((weekD: WeekDaysEnum) => weekD === dow);
      let currentDow: number = nextRunUTC.isoWeekday();

      if (targetDow < currentDow || nextRunUTC.isBefore(nowUTC)) {
        nextRunUTC.add(1, 'week');
      }
      nextRunUTC.isoWeekday(targetDow);
    }

    let nextRunLocal = nextRunUTC.tz(timezone);

    return nextRunLocal.format('MMM DD, HH:mm');
  }
}
